import LineSymbol from './LineSymbol';
import Template from '../geometry/Template';
import Vector from '../math/Vector';
import SymbolFactory from './SymbolFactory';

/**
 * 由点符号构成的线符号,每隔指定间距绘制一遍点符号
 */
export default class VertexLineSymbol extends LineSymbol {
    constructor(options) {
        super(options);

        this.type = 'VertexLineSymbol';
        this.startOffset = 0;
        this.direction = 's2e';
        this.marker = null;

        this.fromJson(options);
    }

    fromJson(json) {
        super.fromJson(json);

        this._setValue('startOffset', json.startOffset);
        this._setValue('direction', json.direction);
        if (json.marker) {
            const symbolFactory = SymbolFactory.getInstance();
            this.marker = symbolFactory.createSymbol(json.marker);
        }
    }

    toJson() {
        const json = super.toJson();

        json.startOffset = this.startOffset;
        json.direction = this.direction;
        if (this.marker) {
            json.marker = this.marker.toJson();
        }

        return json;
    }

    /**
     * 绘制接口.
     * @param {object} ctx - 设备上下文,通过canvas.getContext('2d')方法获得.
     * @returns {undefined}
     */
    draw(ctx, geometry) {
        if (!this.marker) {
            return;
        }
        if (!geometry || !geometry.coordinates || geometry.coordinates.length < 2) {
            return;
        }

        this._drawSegment(ctx, geometry);
    }

    /**
     * 绘制一个小段,绘制前先将线按照template的pattern属性切成N段,然后绘制每一段.
     * @param {object} ctx - 设备上下文
     * @return {undefined}
     */
    _drawSegment(ctx, geometry) {
        // 在每段mark的第一个坐标处绘制marker，方向取当前形状边方向
        let angle = 0;
        for (let i = 0; i < geometry.coordinates.length - 1; ++i) {
            const mark = geometry.coordinates[i];
            const vY = new Vector(0, -1);
            const vN = geometry.coordinates[i + 1].minus(mark);

            angle = vY.angleTo(vN);
            const signal = vY.cross(vN);

            if (signal < 0) {
                angle = -angle;
            }

            this.drawMarker(ctx, angle, mark);
        }
        const lastMark = geometry.coordinates[geometry.coordinates.length - 1];
        this._drawMarker(ctx, angle, lastMark);
    }

    /**
     * 私有方法.
     * @param {object} ctx      - 设备上下文
     * @param {Number} angle    - marker符号的角度
     * @param {object} geometry - marker的几何
     */
    _drawMarker(ctx, angle, geometry) {
        this.marker.angle = angle;
        this.marker.draw(ctx, geometry);
    }
}
